module.exports = __webpack_public_path__ + "static/media/subscript.aa3250a4.svg";